import angular from 'angular';

document.write(require('./view.html').default);
import './style.scss';

angular.module("core.application.module.headerMinor", [
]).controller("core.application.module.headerMinor.controller", [
    "$rootScope", "$scope", "$controller",
    function($rootScope, $scope, $controller) {
        $controller("core.application.module.controller", {$scope: $scope});

        if (! $scope.model.headerMinor) {
            $scope.model.headerMinor = {};
        }

        if (! $rootScope.headerMinor) {
            $rootScope.headerMinor = [];
        }

        $scope.isLinkActive = function(pageName) {
            // pageName: the page name to check if it's active
            //     string if one page name
            //     array of strings if more than one page name
            return pageName.indexOf($scope.activePageName) !== -1;
        };

    }
]);
